var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tabs",class:_vm.$style.tabs},[_c('ul',_vm._l((_vm.documents),function(doc,i){return _c('li',{key:doc.id,class:[
        {
          'is-active': _vm.isActive(doc.id),
          [_vm.$style.isPublished]: _vm.isPublishedDoc(doc),
          [_vm.$style.isDraft]: _vm.isDraftDoc(doc),
          [_vm.$style.isArchived]: _vm.isArchivedDoc(doc)
        },
        !_vm.multiple ? _vm.$style.singleTabStyle : ''
      ],attrs:{"data-test":"project-document-tab"},on:{"mouseover":function($event){_vm.hoveredItemIndex = i},"mouseleave":function($event){_vm.hoveredItemIndex = -1}}},[_c('router-link',{attrs:{"to":{
          name: 'editor',
          params: {
            documentId: doc.id,
            projectId: _vm.projectId
          }
        },"title":doc.title}},[_c('ProjectEditorHeaderTabTag',{attrs:{"active":_vm.hoveredItemIndex === i || _vm.isActive(doc.id),"status":_vm.getDocumentStatus(doc)}},[_vm._v(" "+_vm._s(_vm.getDocTypeDisplayNameFromDoc(doc))+" ")]),_vm._v(" "+_vm._s(doc.title)+" ")],1)],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }